
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DButton',
  props: {
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  }
})
